import plugin from '../../lib/plugin';
import galleryCarousel from './gallery-carousel';

const ELEMENT_SELECTOR = '[data-gallery-carousel]';
const PLUGIN_NAME = 'galleryCarousel';

export function exec() {
    plugin(PLUGIN_NAME, galleryCarousel);
    $(ELEMENT_SELECTOR)[PLUGIN_NAME]();
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/gallery-carousel/index.js